import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { handlePostRequest } from '../service/PostTemplate';
import { endPoints } from '../Config';

/* eslint-disable */

const BlackListDialog = ({ onHide, onClose, blackListMerchantData }) => {
    const dispatch = useDispatch();
    const [loading, setloading] = useState(false);
    console.log(blackListMerchantData, 'blackListMerchantData');
    const formik = useFormik({
        // validationSchema: validationSchema,
        initialValues: {
            reason: '',
            merchantId: '',
            updatedBy: '',
            merchantId: ''
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('adminUser') || '{}');
            const addData = {
                merchantId: blackListMerchantData?.id,
                isBlacklisted: blackListMerchantData?.isBlacklisted ? false : true,
                reason: data.reason,
                updatedBy: user?.data?.userId
            };

            const response = await dispatch(handlePostRequest(addData, endPoints.blackListMerchant, true));
            if (response?.status === 200) {
                formik.resetForm();
                onHide();
            }
            // setLoadingBtn(false);
        }
    });

    return (
        <>
            <form className="p-fluid p-mt-2" onSubmit={formik.handleSubmit}>
                <div className="p-4">
                    <div className="flex justify-content-between align-items-center mb-3">
                        <h3>BlackList Reason</h3>
                    </div>
                    <div className="grid p-fluid">
                        <div className="col-12 md:col-12">
                            <div className="field mb-3">
                         

                                <InputTextarea id="reason" name="reason" placeholder="Reason..." value={formik?.values?.reason} rows={5} cols={30} maxLength={500} onChange={formik.handleChange} />
                            
                                {formik.touched.reason && formik.errors.reason && <small className="p-error">{formik.errors.reason}</small>}
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-center mt-4 gap-2">
                        <Button label={'Save'} icon={'pi pi-save'} type="submit" className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                        <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onClose()} />
                    </div>
                </div>
            </form>
        </>
    );
};

export default BlackListDialog;
